<template>
	<v-dialog v-model="dialog" persistent max-width="700">
		<v-card flat class="fullHeight pa-40 textAlignCenter">
			<h2>{{resolvedMflTitle[selectedMfl]}}</h2>
			<br>
			<table class="mflTable" :class="dark_t?'dark':''">
				<thead>
					<tr>
						<th>Nivel de<br>severidad</th>
						<th>Descripción</th>
						<th>Factor de<br>severidad</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(v, i) in rows"
						:key="i"
						@click="set(v[0])"
						:class="getClass(v[0])">
						<td>{{v[0]}}</td>
						<td>{{v[1]}}</td>
						<td>{{v[2]}}</td>
					</tr>
				</tbody>
			</table>
			<br>
			<v-btn color="secondary" @click="close()">
				<v-icon></v-icon>
				<span>Cerrar</span>
			</v-btn>
		</v-card>
	</v-dialog>
</template>

<script>
import { buildMflDescriptionTables, mflTitleForVersion } from '@/objects/mfl_global_risk.js';

export default {
	props:{
		dialog: {},
		item: { default: () => ({}) },
		selectedMfl: {},
		edit: { default: true}
	},
  data() {
    return {
			checkResidual: {
				health_and_safety_residual: 'mfl_health_and_safety',
				environment_residual: 'mfl_environment',
				community_residual: 'mfl_community',
				legal_residual: 'mfl_legal',
				reputation_residual: 'mfl_reputation',
				sustainability_residual: 'mfl_sustainability',
			},
    };
	},
	created() { },
  watch: { },
  computed: {
		mfls() {
			return buildMflDescriptionTables(this.item.global_risk_standard_version);
		},
		resolvedMflTitle() {
			return mflTitleForVersion(this.item.global_risk_standard_version);
		},
		rows() { return this.mfls[this.selectedMfl] || []; },
  },
  methods: {
		canSet(v) {
			const toCheck = this.checkResidual[this.selectedMfl];
			if (!toCheck) return true;
			return v <= this.item[toCheck];
		},
		getClass(v){
			if (this.item[this.selectedMfl] === v) return 'selected';
			if (!this.canSet(v)) return 'disabled';
			return '';
		},
		set(v) {
			if (this.edit === false)  return;
			if (!this.canSet(v)) {
				const toCheck = this.checkResidual[this.selectedMfl];
				this.setSnackbar({
					message: `${this.resolvedMflTitle[this.selectedMfl]} no puede ser mayor que ${this.resolvedMflTitle[toCheck]}.`,
					class: 'error',
					timeout: 6000,
					'multi-line': true,
					clearable: true,
				})
				return;
			}
			if (!['mfl_financial', 'financial_residual'].includes(this.selectedMfl)) {
				this.item[this.selectedMfl] = v;
			}
			this.close();
		},
		close() { this.$emit('update:dialog', false) },
  },
};
</script>